var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M.5 8.5h23v6H.5v-6zm24-1h-25v8h25v-8z"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#000",
      "stroke-linecap": "round",
      "d": "M3.5 11.27h17.558"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }